module.exports = __webpack_public_path__ + "img/Logo-red.d433f712.png";